export enum LOADER_STATUS {
  DEFAULT,
  LOADING,
  SUCCESS,
  FAILURE
};